// extracted by mini-css-extract-plugin
export var contrastLow = "_3v-1";
export var externalLink = "_3v-2";
export var externalLinkIcon = "_3v-3";
export var link = "_3v-0";
export var linkLabel = "_3v-4";